import { ButtonMain } from '@/modules/common/components/button';
import styles from './index.module.sass';
import letterSvg from '@@/offer/images/letter.svg';
import { Link, useNavigate } from 'react-router-dom';
import { IIncomingOffer, ITradeGroup } from '../../types/business-offer';
import useItems from 'antd/es/menu/hooks/useItems';
import { numberToReadable } from '@/modules/common/helpers/number-to-readable.helper';
import { compareDateWithCurrentTime } from '@/modules/common/helpers/compare-date.helper';
import { WITHOUT_VAT } from '@/shared/constants/price.constants';

export const OfferContractItem = ({ data, onClick }: IArgs) => {
  const navigate = useNavigate();
  return (
    <div className={styles.root}>
      <div className={styles.topInfo}>
        <h4>Контрагент №{data.company_id} </h4>
        {/* <a
          className={styles.showDetails}
          href='##'
          onClick={(e) => { e.preventDefault(); onClick() }}
        >
          завершить сделку
        </a> */}
      </div>
      <div className={styles.deadline}>
        <span className={styles.label}>сроки проведения отгрузки со склада</span>
        {data.max_date === data.min_date ? (
          <span className={styles.start}>
            {compareDateWithCurrentTime(String(data.min_date))}
          </span>
        ) : (
          <>
            от{' '}
            <span className={styles.start}>
              {compareDateWithCurrentTime(String(data.min_date))}
            </span>{' '}
            до{' '}
            <span className={styles.finish}>
              {compareDateWithCurrentTime(String(data.max_date))}
            </span>
          </>
        )}
      </div>
      <div className={styles.buyerInfo}>
        <div className={styles.data}>
          <span className={styles.title}>{data.company_name}</span>
          <span className={styles.buyerType}>
            {data.external ? 'внешний контрагент' : 'ваш контрагент'}
          </span>
        </div>
        <div className={styles.icon}>
          <img src={letterSvg} />
        </div>
      </div>
      <div className={styles.metrics}>
        <div className={styles.metric}>
          <span className={styles.label}>количество сделок</span>
          <span className={styles.value}>{data.number_of_positions || 0} шт</span>
        </div>
        <div className={styles.metric}>
          <span className={styles.label}>общий вес всех сделок</span>
          <span className={styles.value}>
            {Number(data.total_weight).toLocaleString('ru', {
              maximumFractionDigits: 2,
            })}{' '}
            т
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.label}>стоимость всех сделок {WITHOUT_VAT}</span>
          <span className={styles.value}>{numberToReadable(+data.total)} ₽</span>
        </div>
        <div className={styles.metric}>
          <span className={styles.label}>стоимость логистики всех сделок</span>
          <span className={styles.value}>
            {numberToReadable(+data.total_logistic)} ₽{' '}
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.label}>
            сумма всех сделок с учетом логистики {WITHOUT_VAT}
          </span>
          <span className={styles.value}>
            {numberToReadable(+data.total - +data.total_logistic)} ₽{' '}
          </span>
        </div>
      </div>
      <ButtonMain
        className={styles.finishContract}
        label="показать детали"
        onClick={() =>
          navigate(
            `/offer/contracts/${data.company_id}?buyerable_id=${data.company_id}&buyerable_type=${data.company_type}`,
          )
        }
      />
    </div>
  );
};

interface IArgs {
  data: ITradeGroup;
  onClick: () => void;
}
